// Generated by purs version 0.13.8
"use strict";
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_HTML_Properties_ARIA = require("../Halogen.HTML.Properties.ARIA/index.js");
var Top = (function () {
    function Top() {

    };
    Top.value = new Top();
    return Top;
})();
var TopLeft = (function () {
    function TopLeft() {

    };
    TopLeft.value = new TopLeft();
    return TopLeft;
})();
var TopRight = (function () {
    function TopRight() {

    };
    TopRight.value = new TopRight();
    return TopRight;
})();
var Bottom = (function () {
    function Bottom() {

    };
    Bottom.value = new Bottom();
    return Bottom;
})();
var BottomLeft = (function () {
    function BottomLeft() {

    };
    BottomLeft.value = new BottomLeft();
    return BottomLeft;
})();
var BottomRight = (function () {
    function BottomRight() {

    };
    BottomRight.value = new BottomRight();
    return BottomRight;
})();
var Left = (function () {
    function Left() {

    };
    Left.value = new Left();
    return Left;
})();
var Right = (function () {
    function Right() {

    };
    Right.value = new Right();
    return Right;
})();
var showTooltipPosition = new Data_Show.Show(function (v) {
    if (v instanceof Top) {
        return "top";
    };
    if (v instanceof TopLeft) {
        return "top-left";
    };
    if (v instanceof TopRight) {
        return "top-right";
    };
    if (v instanceof Bottom) {
        return "bottom";
    };
    if (v instanceof BottomLeft) {
        return "bottom-left";
    };
    if (v instanceof BottomRight) {
        return "bottom-right";
    };
    if (v instanceof Left) {
        return "left";
    };
    if (v instanceof Right) {
        return "right";
    };
    throw new Error("Failed pattern match at Lunarbox.Component.Tooltip (line 17, column 1 - line 25, column 23): " + [ v.constructor.name ]);
});
var tooltip = function (text) {
    return function (position) {
        return function (element) {
            return function (extraAttribs) {
                var attribs = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Properties_ARIA.role("tooltip"), Halogen_HTML_Properties_ARIA.label(text), Halogen_HTML_Properties.attr("data-microtip-position")(Data_Show.show(showTooltipPosition)(position)) ])(extraAttribs);
                return element(attribs);
            };
        };
    };
};
module.exports = {
    Top: Top,
    TopLeft: TopLeft,
    TopRight: TopRight,
    Bottom: Bottom,
    BottomLeft: BottomLeft,
    BottomRight: BottomRight,
    Left: Left,
    Right: Right,
    tooltip: tooltip,
    showTooltipPosition: showTooltipPosition
};
